import { DraftConfigurationText } from '@/types';
import { getBendingTextSizeForStyle } from './getBendingTextSizeForStyle';

export const getBendingTextSize = (text: DraftConfigurationText) =>
  getBendingTextSizeForStyle(text.style, text.content);
